// extracted by mini-css-extract-plugin
export default {"wrapper":"Forget_wrapper__mn-Z-","content":"Forget_content__K4Qy3","title":"Forget_title__ziDn+","description":"Forget_description__x0Cqf","form":"Forget_form__CJ2cw"};